export const PixKeyData = [
    { value: 'celular', label: 'Celular' },
    { value: 'chave aleatória', label: 'Chave aletória' },
    { value: 'email', label: 'E-mail' },
    { value: 'CPF', label: 'CPF' },
    { value: 'CNPJ', label: 'CNPJ' },
];
